import { render, staticRenderFns } from "./qualitycontrol.vue?vue&type=template&id=33efddeb"
import script from "./qualitycontrol.vue?vue&type=script&lang=js"
export * from "./qualitycontrol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports